<template>
    <div class="menu-system-component">
    <v-navigation-drawer
            v-model="drawer"
            :mini-variant.sync="mini"
            :color="color"
            dark
            clipped
            app
            width="198"
    >
        <v-list dense class="pt-12">

            <template v-for="item in items">
                <v-list-group
                        v-if="item.items && item.items.length"
                        :key="item.title"
                        v-model="item.active"
                        :prepend-icon="item.icon"
                        no-action
                        active-class="m-active"

                >
                    <template v-slot:activator>
                        <v-list-item-content>
                            <v-list-item-title v-text="item.title"></v-list-item-title>
                        </v-list-item-content>
                    </template>

                    <v-list-item
                            v-for="subItem in item.items"
                            :key="subItem.title"
                            @click=""
                            :to="subItem.href"
                            class="font-family-2 font-size-13"
                            active-class="m-active"
                    >
                        <v-list-item-icon>
                            <v-icon>{{ subItem.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title v-text="subItem.title"></v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>

                <v-list-item
                        :key="item.title"
                        class="font-family-2 font-size-13"
                        link
                        v-else
                        @click=""
                        :to="item.href"
                        active-class="m-active"
                >
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

            </template>


            <v-btn
                    block
                    color="rgba(0,0,0,.5)"
                    absolute
                    bottom
                    icon
                    @click.stop="mini = !mini"
            >
                <v-icon>mdi-backburger</v-icon>
            </v-btn>
        </v-list>

    </v-navigation-drawer>
    <v-app-bar
            app
            color="#FFF"
            height="65px"
            clipped-left
            class="elevation-0 border-bottom-1"
    >
    <v-app-bar-nav-icon class="d-md-none d-sm-flex" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <div class="d-flex align-center ">
            <v-img
                    alt="Neocity Logo"
                    class="shrink mr-10"
                    contain
                    src="@/assets/images/neocity-logo.png"
                    transition="scale-transition"
                    height="50px"
                    width="157px"
            />
            <span class="font-family-1 title-nav d-none d-md-flex">Sistema de Administración de planes de Energía</span>


        </div>

        <v-spacer></v-spacer>
        <span class="font-family-2 pr-6 date-nav-text d-none d-md-flex">Santiago, 30 de Junio de 2020 </span>
        <v-menu offset-y tile>
            <template v-slot:activator="{ on, attrs }">
                <v-badge

                        color="#FFC124"
                        bottom
                        content="3"
                        offset-x="30"
                >
                    <v-avatar size="40" v-on="on">
                        <v-img src="@/assets/images/perfil.png"></v-img>
                    </v-avatar>
                </v-badge>
                <a href="#" class="mr-5 font-family-2 text-decoration-none font-size-13 d-none d-md-flex" v-on="on" > Hola Nombre Apellido </a>

            </template>

            <v-list dark color="primary" dense>
                <v-list-item>
                    <v-list-item-title><b>Notificaciones</b></v-list-item-title>
                    <v-list-item-icon>3</v-list-item-icon>
                </v-list-item>
                <v-list-item
                        v-for="(item, index) in notifications"
                        :key="index"
                        @click=""
                >
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item>
            </v-list>
            <v-list color="#E8E8E8" dense>
                <v-list-item to='/system/profile-company' @click="">
                    <v-list-item-title>Ver Perfil de Empresa</v-list-item-title>
                </v-list-item>
                <v-list-item @click="">
                    <v-list-item-title>Configuraciones</v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item @click="" to="/">
                    <v-list-item-title>Cerrar session</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>

        <v-btn icon>
            <v-icon>mdi-dots-vertical</v-icon>

        </v-btn>
        <v-btn icon>
            <v-icon>mdi-help-circle</v-icon>
        </v-btn>
    </v-app-bar>
    </div>
</template>
<style lang="scss">
   
    .m-active{
        background: rgba(0,0,0,.2) !important;
        color: #FFFFFF !important;
        border-left:3px solid #FFFFFF;
    }
   .v-application--is-ltr .v-list-group--no-action > .v-list-group__items > .v-list-item{
        padding-left: 30px !important;
    }
   .v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child{
        margin-right: 12px !important;
    }
    .v-list-item--link:before {
     background: rgba(0,0,0,.2) !important;
    }
    .v-list--dense .v-list-item .v-list-item__title{
        font-weight: normal;
    }
</style>
<script>
    export default {
        name: 'MenuSystemComponent',
        props: [ 'items','notifications','color'],
        data() {
            return {
                drawer: true,
                mini: true,
            }
        }
    }
</script>